<template>
    <div class="status-container" >
        <div class="status-body" v-if="showBody">
            <Card :bordered="false" dis-hover>
                <p slot="title">
                    <Icon type="ios-barcode-outline"></Icon>
                    Console
                </p>
                <p slot="extra">    
                    <Tooltip content="清空日志" placement="top">
                        <Icon type="md-trash"></Icon>
                    </Tooltip>
                    <Tooltip content="关闭" placement="top-end">
                        <Icon type="md-close" @click.native="showBody=false"></Icon>
                    </Tooltip>
                </p>
                <Scroll :height="150">
                    <CellGroup>
                        <log-item type="error"/>
                        <log-item type="success" text='服务器启动成功' title='server start'/>
                        <log-item type="info" title='info'/>
                        <log-item type="warning" title='warning'/>
                        <log-item type="warning" title='warning'/>
                        <log-item type="warning" title='warning'/>
                        <log-item type="warning" title='warning'/>
                    </CellGroup>
                </Scroll>
            </Card>
        </div>
        <div class="status-bar">
            <Label type="info" text="INFO" @click.native="showBody=!showBody" />
        </div>
    </div>
</template>

<script>
import LogItem from './status-bar-item.vue'
import Label from '@/components/label'

export default {
    data(){
        return {
            showBody:false
        }
    },
    components:{LogItem,Label}
}
</script>